(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier21b-onglets-livre"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('a21b-book-tabs')) {

    customElements.define('a21b-book-tabs', class extends HTMLElement {

      connectedCallback() {

        if (this._controller) this._controller.abort();

        this._controller = new AbortController();

        this._formatWhy();

        const options = { signal: this._controller.signal };

        const tablist = this.querySelector('[data-tablist]');

        const tabs = [...this.querySelectorAll('[data-tab]')];

        const panels = tabs.map(tab => this.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls'))));

        if (!tablist || !tabs.length || panels.some(panel => !panel)) return;



        this._activate = (index, focus = false) => {

          tabs.forEach((tab, position) => {

            const active = position === index;

            tab.setAttribute('aria-selected', String(active));

            tab.tabIndex = active ? 0 : -1;

            const panel = panels[position];

            panel.hidden = !active;

            panel.setAttribute('role', 'tabpanel');

            panel.setAttribute('aria-labelledby', tab.id);

            panel.tabIndex = 0;

          });

          if (focus) tabs[index].focus();

        };



        tabs.forEach((tab, index) => {

          tab.addEventListener('click', () => this._activate(index), options);

          tab.addEventListener('keydown', event => {

            let next;

            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;

            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;

            if (event.key === 'Home') next = 0;

            if (event.key === 'End') next = tabs.length - 1;

            if (next === undefined) return;

            event.preventDefault();

            this._activate(next, true);

          }, options);

        });



        this.setAttribute('data-enhanced', '');

        tablist.hidden = false;

        const previous = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');

        this._activate(previous >= 0 ? previous : 0);

      }



      _formatWhy() {

        const prose = this.querySelector('[data-book-description]');

        if (!prose) return;



        const normalize = text => (text || '')

          .normalize('NFKD')

          .replace(/[\u0300-\u036f]/g, '')

          .replace(/[\u2018\u2019\u02bc]/g, "'")

          .toLowerCase()

          .replace(/\s+/g, ' ')

          .trim()

          .replace(/^[^a-z]+|[^a-z]+$/g, '');

        const titles = new Set([

          "pourquoi on l'aime",

          'pourquoi on aime ce livre',

          'pourquoi on aime',

          "pourquoi nous l'aimons",

          'pourquoi nous aimons ce livre'

        ]);



        for (const element of prose.querySelectorAll('p, h1, h2, h3, h4, h5, h6, div, strong, b')) {

          if (element.closest('.a21b-why') || !titles.has(normalize(element.textContent))) continue;



          let title = element;

          while (title.parentElement && title.parentElement !== prose &&

                 titles.has(normalize(title.parentElement.textContent))) {

            title = title.parentElement;

          }



          const spacers = [];

          let list = title.nextElementSibling;

          while (list && (list.tagName === 'BR' ||

                 (list.tagName === 'P' && !list.textContent.trim() &&

                  !list.querySelector('img, video, iframe, svg')))) {

            spacers.push(list);

            list = list.nextElementSibling;

          }

          if (!list || !['UL', 'OL'].includes(list.tagName)) continue;



          const box = prose.ownerDocument.createElement('div');

          box.className = 'a21b-why';

          title.before(box);

          box.append(title, ...spacers, list);

        }

      }



      disconnectedCallback() {

        if (this._controller) this._controller.abort();

      }

    });

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
